import { useTimeoutPoll } from '@vueuse/core';
import { onBeforeUnmount, watch, type Ref } from 'vue';

export default (
  watchValues: Array<Ref<boolean>>,
  pollCallback: () => Promise<void> | void,
  interval: number = 3000,
  immediate: boolean = true,
) => {
  const { isActive, pause: pausePoll, resume: resumePoll } = useTimeoutPoll(pollCallback, interval);

  watch(
    watchValues,
    (currentValues: boolean[]) => {
      const shouldPoll = currentValues.some(Boolean);

      if (shouldPoll && !isActive.value) {
        resumePoll();
        return;
      }

      if (!shouldPoll && isActive.value) {
        pausePoll();
      }
    },
    { immediate: immediate },
  );

  onBeforeUnmount(() => {
    pausePoll();
  });
};
